import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'relativeOrDate',
  standalone: true
})
export class RelativeOrDatePipe implements PipeTransform {
  transform(value: any): string {
    if (!value) return '';
    
    let dateStr = value;
    if (typeof dateStr === 'string' && !dateStr.includes('Z') && dateStr.includes('T')) {
      dateStr = dateStr.split('.')[0] + 'Z';
    }
    
    const now = new Date();
    const date = new Date(dateStr);
    
    if (isNaN(date.getTime())) {
      return value;
    }
    
    const diffMs = now.getTime() - date.getTime();
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr / 24);
    const diffMonth = Math.floor(diffDay / 30);

    if (diffMonth >= 1) {
      return formatDate(date, 'MM-dd-yyyy hh:mm a', 'en-US');
    } else if (diffDay >= 1) {
      return diffDay === 1 ? '1 day ago' : `${diffDay} days ago`;
    } else if (diffHr >= 1) {
      return diffHr === 1 ? '1 hour ago' : `${diffHr} hours ago`;
    } else if (diffMin >= 1) {
      return diffMin === 1 ? '1 minute ago' : `${diffMin} minutes ago`;
    } else {
      return 'just now';
    }
  }
}
